/**
 * RewindPrompt — HUD element (extracted from PixiHUDRenderer.js in Phase 3D).
 *
 * create(hud) builds the PIXI objects into hud.elements.rewindPrompt,
 * position(hud) lays them out for hud.screenWidth/Height, update(hud, …) redraws
 * from game state. `hud` is the PixiHUDRenderer coordinator: it owns
 * hudContainer, elements, screen size, _createText() and send().
 */
import * as PIXI from 'pixi.js';

/**
 * Create rewind ability prompt
 */
export function create(hud) {
  const container = new PIXI.Container();
  container.visible = false;
  hud.hudContainer.addChild(container);

  // Text with outline effect
  const text = new PIXI.Text({
    text: 'Press L Shift to Rewind',
    style: {
      fontFamily: 'Arial',
      fontSize: 24,
      fontWeight: 'bold',
      fill: 0x00d4ff,
      stroke: { color: 0x000000, width: 5 }
    }
  });
  text.anchor.set(0.5, 0.5);
  container.addChild(text);

  hud.elements.rewindPrompt = { container, text };
  hud._positionRewindPrompt();
}

/**
 * Position rewind prompt
 */
export function position(hud) {
  const rp = hud.elements.rewindPrompt;
  if (!rp) return;

  rp.container.x = hud.screenWidth / 2;
  rp.container.y = hud.screenHeight - 120;
}

/**
 * Update rewind prompt visibility
 * @param {Object} gameState - Game state
 */
export function update(hud, gameState) {
  const rp = hud.elements.rewindPrompt;
  if (!rp) return;

  const abilityState = gameState.abilityState;
  const rewindEffect = abilityState?.activeEffects?.['rewind'];
  const isRewindActive = !!rewindEffect;

  rp.container.visible = isRewindActive;
}
